export class Document {
    public Name!: string;
    public Code!: string;
    public Date!: Date;
    // public Data!: File;
    public ContentType?: string;

    static mapFromJSON(json: any): Document {

        let d = new Document();
        d.Code = json.code;
        d.Name = json.name;
        d.Date = json.date;
        d.ContentType = json.contentType;
        // d.Data = json.data;

        return d;
    }
}